import React from 'react'
import Title from './Title.jsx'
import NumberedList from './NumberedList.jsx'
import SideImage from './SideImage.jsx'
import Button from '../components/Button.jsx'

const ServicesItem = (props) => {
    let offsetClass = ''
    let imageClass = 'services-item-images--right'
    let mobileImageClass = 'services-item-images-mobile--right'
    if (props.textOnRight) {
        offsetClass = 'col-md-offset-7'
        imageClass = ''
        mobileImageClass = 'services-item-images-mobile--left'
    }

    return (
        <div className="services-item">
            <div className={`services-item-images-mobile visible-sm visible-xs ${mobileImageClass}`}>
                <SideImage
                    backgroundImage={props.backgroundImage}
                    foregroundImage={props.foregroundImage}
                    foregroundTop={props.foregroundTop}
                />
            </div>
            <div className="container">
                <div className="row">
                    <div className={`col-md-5 ${offsetClass}`}>
                        <Title
                            title={props.title}
                            className="header1--small header1--small-margin hidden-sm hidden-xs"
                        />
                        <Title
                            title={props.title}
                            className="header1--small header1--center header1--small-margin visible-sm visible-xs"
                        />
                        <div className="services-item__list">
                            <NumberedList
                                text={props.text}
                                itemArray={props.itemArray}
                            />
                        </div>
                        <div className="handkey-button">
                            <div className="handkey-button__line"></div>
                            <div className="handkey-button__button">
                                <Button
                                    link={props.link}
                                    text={props.buttonTitle}
                                    type="arrow"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`services-item-images hidden-sm hidden-xs ${imageClass}`}>
                <SideImage
                    backgroundImage={props.backgroundImage}
                    foregroundImage={props.foregroundImage}
                    foregroundTop={props.foregroundTop}
                />
            </div>
        </div>
    )
}

ServicesItem.defaultProps = {
    textOnRight: true,
    backgroundImage: '',
    foregroundImage: '',
    title: '',
    text: '',
    itemArray: [],
    foregroundTop: '12%',
    buttonTitle: 'wrong title!!!!!!!!',
    link: '404'
}

export default ServicesItem



// WEBPACK FOOTER //
// ./src/scripts/components/ServicesItem.jsx